import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetsHostDirective } from '../directives/widgets-host.directive';
import { WidgetComponent } from './widget/widget.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchTermFilterPipe, ExcludeItemsPipe} from '../shared/search.pipe';
import { KfbsNglibModule } from 'kfbs-nglib';
import { LoadingOrErrorComponent } from './loading-or-error/loading-or-error.component';
//import { GoogleChartsModule } from 'angular-google-charts';
import { NgbdSortableHeaderDirective } from '../directives/table-column-sortable.directive';
import { ReplacePipe } from '../shared/replace.pipe';
import { LinksFilterPipe } from '../shared/links-filter.pipe';
import { DegreeAuditFilterPipe } from '../shared/degree-audit.pipe';
import { LocalTimeZonePipe, SectionsStartsInTermFilter, TermsFilter } from '../pages/course-catalog/course-catalog.component';
import { ComponentsHostDirective } from '../directives/components-host.directive';
import { BiddingStatusPipe } from '../services/bidding.service';
import { ConflictComponent } from './conflict/conflict.component';
import { FacultyRoleFilterPipe, DaysLeftPipe } from '../shared/faculty.pipe'; 
import { PeopleDownloadButtonsComponent } from '../pages/people/people-download/people-download-buttons.component';
import { OrderByPipe } from './order-by.pipe';
import { ArrayBuilder } from '../core/editable-fields/array-builder/array-builder.component';
import { BooleanSlider } from '../core/editable-fields/boolean-slider/boolean-slider.component';
import { DateTime } from '../core/editable-fields/date-time/date-time.component';
import { Dropdown } from '../core/editable-fields/dropdown/dropdown.component';
import { FileUpload } from '../core/editable-fields/file-upload/file-upload.component';
import { RadioList } from '../core/editable-fields/radio-list/radio-list.component';
import { TextInput } from '../core/editable-fields/text-input/text-input.component';
import { TypeaheadBinderPipe } from './pipes/typeahead-binder.pipe';
import { ListOptionPipe } from './pipes/list-option.pipe';
import { ObservablePipe } from './pipes/to-observable.pipe';
import { RichTextInput } from '../core/editable-fields/rich-text-input/rich-text-input.component';
import { ErrorsWarningsComponent } from '../core/editable-fields/errors-warnings/errors-warnings.component';
import { RtiUrlModalComponent } from '../core/editable-fields/rich-text-input/url-modal/rti-url-modal.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,       
        ErrorsWarningsComponent,
        DateTime,
        Dropdown,
    ],
    declarations: [
        WidgetComponent,
        WidgetsHostDirective,
        ComponentsHostDirective,
        SearchTermFilterPipe,
        ExcludeItemsPipe,
        LoadingOrErrorComponent,
        NgbdSortableHeaderDirective,
        LocalTimeZonePipe,
        BiddingStatusPipe,
        ReplacePipe,
        LinksFilterPipe,
        DegreeAuditFilterPipe,
        TermsFilter,
        SectionsStartsInTermFilter,
        ConflictComponent,
        FacultyRoleFilterPipe,
        DaysLeftPipe,
        PeopleDownloadButtonsComponent,
        OrderByPipe,
        ArrayBuilder,
        BooleanSlider,
        FileUpload,
        RadioList,
        TextInput,
        TypeaheadBinderPipe,
        ListOptionPipe,
        ObservablePipe,
        RichTextInput,
        RtiUrlModalComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        WidgetComponent,
        WidgetsHostDirective,
        ComponentsHostDirective,
        SearchTermFilterPipe,
        ExcludeItemsPipe,
        KfbsNglibModule,
        LoadingOrErrorComponent,        
        NgbdSortableHeaderDirective,
        LocalTimeZonePipe,
        BiddingStatusPipe,
        ReplacePipe,
        LinksFilterPipe,
        DegreeAuditFilterPipe,
        TermsFilter,
        SectionsStartsInTermFilter,
        ConflictComponent,
        FacultyRoleFilterPipe,
        DaysLeftPipe,
        PeopleDownloadButtonsComponent,
        OrderByPipe,
        ArrayBuilder,
        BooleanSlider,
        DateTime,
        Dropdown,
        FileUpload,
        RadioList,
        TextInput,
        TypeaheadBinderPipe,
        ListOptionPipe,
        ObservablePipe,
        RichTextInput,
        ErrorsWarningsComponent,
        RtiUrlModalComponent,
    ],
    providers: [
        FacultyRoleFilterPipe,
        DaysLeftPipe
    ]
})
export class SharedModule { }
